import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { LocationService } from 'src/app/public/location.service';

@Component({
  selector: 'app-profile-title',
  templateUrl: './profile-title.component.html',
  styleUrl: './profile-title.component.scss',
})
export class ProfileTitleComponent {
  @Input() title: string = '';
  @Input() showMenu: boolean = false;
  @Input() backTo: string = '';

  constructor(
    private locationService: LocationService,
    private router: Router,
  ) {}

  back(event: Event) {
    event.preventDefault();
    this.router.navigateByUrl(this.locationService.base_url(this.backTo));
  }
}
